export default {
  emailPlaceholder: 'Nombre o correo electrónico',
  rolePlaceholder: 'Rol',
  levelsPlaceholder: 'Niveles',
  statusPlaceholder: 'Estado',
  inviteNewMembers: 'Invitar nuevos integrantes',
  search: 'Buscar',
  cleanSearch: 'Limpiar filtros',
  roles: {
    none: 'Todos los roles',
    manager: 'Directivo',
    teacher: 'Docente'
  },
  levels: {
    none: 'Todos los niveles',
    primary: 'Primario',
    secondary: 'Secundario'
  },
  status: {
    none: 'Todos los estados',
    confirmed: 'Confirmado',
    pending: 'Pendiente',
    canceled: 'Expirado'
  }
}

export const en = {
  emailPlaceholder: 'Name or email',
  rolePlaceholder: 'Role',
  levelsPlaceholder: 'Levels',
  statusPlaceholder: 'Status',
  inviteNewMembers: 'Invite new members',
  search: 'Search',
  cleanSearch: 'Clear filters',
  roles: {
    none: 'All roles',
    manager: 'Management',
    teacher: 'Teacher'
  },
  levels: {
    none: 'All levels',
    primary: 'Primary',
    secondary: 'Secondary'
  },
  status: {
    none: 'All states',
    confirmed: 'Confirmed',
    pending: 'Pending',
    canceled: 'Expired'
  }
}

export const ca = {
  emailPlaceholder: 'Nom o correu electrònic',
  rolePlaceholder: 'Rol',
  levelsPlaceholder: 'Nivells',
  statusPlaceholder: 'Estat',
  inviteNewMembers: 'Convidar nous integrants',
  search: 'Buscar',
  cleanSearch: 'Netejar filtres',
  roles: {
    none: 'Tots els rols',
    manager: 'Directiu',
    teacher: 'Docent'
  },
  levels: {
    none: 'Tots els nivells',
    primary: 'Primari',
    secondary: 'Secundari'
  },
  status: {
    none: 'Tots els estats',
    confirmed: 'Confirmat',
    pending: 'Pendent',
    canceled: 'Expirat'
  }
}
